import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  ROUTE: `${cleanedFilename(__filename)}-route`,
};
